import { useTranslation } from "react-i18next";
import TitleAndHeader from "~/components/TitleAndHeader";
import { handle } from "../_.segments/route";
import SideSlider from "~/components/SideSlider";
import { useLoaderData } from "@remix-run/react";
import { loader } from "./route";
import DesignerSlide from "~/components/swiper/DesignerSlide";
import { localeAttr } from "~/utils/helper";
import useHost from "~/utils/hooks/useHost";

export default function OurDesigners() {
  const { designers, locale } = useLoaderData<typeof loader>();
  const { t } = useTranslation(handle.i18n);
  const host = useHost();

  return (
    <section className=" mt-24 flex flex-col items-center">
      <TitleAndHeader
        header={t("designers.slider.header")}
        title={t("designers.slider.title")}
      />
      <SideSlider
        id={1}
        slides={
          designers?.map((w) => (
            <DesignerSlide
              key={w.id}
              locale={locale}
              title={localeAttr(w.attributes, "name", locale)}
              description={localeAttr(w.attributes, "brief", locale)}
              img={host + w.attributes.image.data?.attributes.url ?? ""}
              location={localeAttr(w.attributes, "location", locale)}
              skill={localeAttr(w.attributes, "skill", locale)}
            />
          )) ?? []
        }
        className="mt-12"
      >
        <p className="text-2xl text-Secondary-Crayola-Space-Cs-600">
          {t("designers.slider.description")}
        </p>
      </SideSlider>
    </section>
  );
}
